import * as React from "react";
import { useGetCertificationsQuery } from "../services/certification.service";
import { Certification } from "../types/certification";
import SelectData from "./global/SelectData";

const SelectCertifications = ({
  onChange,
  values,
  label = "Certificates",
  error,
  helperText,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const { data: certs, isLoading } = useGetCertificationsQuery();

  return (
    <SelectData
      data={certs}
      getOptionLabel={(cert) => cert.name}
      getOptionValue={(cert) => cert.id}
      values={values}
      onMultiChange={onChange}
      isMulti={true}
      label={label}
      placeholder="Search certificates..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
    />
  );
};
export default SelectCertifications;
